import { environment } from 'src/environments/environment';
import { User } from '../shared/interfaces/user.interface';

export function getFileUrl(user: User): string {
  let fileName = user.avatar?.file_name;
  if (!fileName) {
    return null;
  }
  return environment.endPointApi + 'user/avatar/' + fileName;
}
